import { createContext, useContext } from "react";
import { useLocation } from "react-router-dom";
import fr from "@/i18n/fr";
import en from "@/i18n/en";

const DICT = { fr, en };
const LangContext = createContext(null);

export const localize = (path, lang) =>
  lang === "en" ? (path === "/" ? "/en" : `/en${path}`) : path;

export const LangProvider = ({ lang, children }) => {
  const { pathname } = useLocation();
  const basePath = lang === "en" ? pathname.replace(/^\/en/, "") || "/" : pathname;
  const value = { lang, t: DICT[lang], basePath, to: (p) => localize(p, lang) };
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
